<div class="srm-overlay" (click)="onCancel()">
  <div class="srm-modal" (click)="$event.stopPropagation()">
    <header class="srm-head">
      <div class="srm-head-titleblock">
        <h2 class="srm-title">Price Code</h2>
        <p class="srm-sub">Restrict to price codes — each seeds a test row</p>
      </div>
      <button type="button" class="srm-close" (click)="onCancel()" aria-label="Close">×</button>
    </header>

    <div class="srm-body">
      <div class="srm-chip-row" *ngIf="selectedList().length">
        <span class="srm-chip" *ngFor="let code of selectedList(); trackBy: trackCode">
          {{ code }}
          <button type="button" class="srm-chip-x" (click)="removeCode(code)" aria-label="Remove">×</button>
        </span>
      </div>

      <div class="srm-field">
        <span class="srm-label">Add a price code</span>
        <div class="srm-toolbar">
          <input type="text" class="srm-input" placeholder="e.g. VIP01"
                 aria-label="Add a price code"
                 [(ngModel)]="manualEntry"
                 (keyup.enter)="addManual()" style="flex:1" />
          <button type="button" class="srm-btn srm-btn-save" (click)="addManual()">Add</button>
        </div>
      </div>

      <div class="srm-field" *ngIf="priceCodes.length">
        <span class="srm-label">From loaded barcodes</span>
        <input type="text" class="srm-search" placeholder="Search price codes…"
               [(ngModel)]="searchText" />
        <div class="srm-list">
          <div class="srm-list-scroll">
            <label class="srm-list-row"
                   *ngFor="let code of filteredOptions(); trackBy: trackCode"
                   [class.srm-list-row--selected]="isSelected(code)">
              <input type="checkbox" [checked]="isSelected(code)" (change)="toggleCode(code)" />
              <span class="srm-row-name">{{ code }}</span>
            </label>
            <div class="srm-empty" *ngIf="!filteredOptions().length">No price codes match.</div>
          </div>
        </div>
      </div>
    </div>

    <footer class="srm-foot">
      <button type="button" class="srm-btn srm-btn-cancel" (click)="onCancel()">Cancel</button>
      <button type="button" class="srm-btn srm-btn-save"
              [disabled]="!selectedList().length" (click)="onConfirm()">Save rule</button>
    </footer>
  </div>
</div>
